module.exports = __webpack_public_path__ + "img/b2bLogin.23081200.jpg";